<textarea nz-input [(ngModel)]="value" (ngModelChange)="onModelChange($event)" [maxLength]="maxlength" [rows]="rows"
  [readOnly]="readonly" [class.text-uppercase]="uppercase"
  [class]="readonly ? 'bg-grey-lighter' : ''" (click)="onClick($event.target)" >
</textarea>
